import styled from 'styled-components';
import * as Check from '@radix-ui/react-checkbox';
import { pxToRem } from 'utils/convert';
import {
  colors,
  spacing,
  subtleShadow,
  duration,
  easing,
  borderRadius,
  body2Medium,
  caption,
} from 'ui/theme';
import {
  getBoxShadowColor,
  getOutlineColor,
  getBackgroundColor,
  getBorderColor,
} from './Styled.utils';

export const IconWrapper = styled(Check.Indicator)`
  align-items: center;
  display: inline-flex;
  justify-content: center;
  min-height: ${spacing.half};
  path {
    stroke: transparent;
    fill: ${colors.iconOnColor};
  }
  .indeterminate path {
    stroke: ${colors.iconOnColor};
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: flex-start;
`;

export const StyledCheckbox = styled(Check.Root)`
  align-items: center;
  appearance: none;
  background-color: ${({ disabled, checked }) => getBackgroundColor(!!checked, !!disabled)};
  border: solid ${spacing.single}
    ${({ checked, disabled }) => getBorderColor(!!checked, !!disabled)};
  border-radius: ${borderRadius.md};
  box-shadow: ${subtleShadow.boxShadow};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  flex: 0 0 auto;
  height: ${spacing.plusQuarter};
  justify-content: center;
  line-height: ${spacing.plusQuarter};
  margin: ${spacing.eighth};
  padding: 0;
  transition: all ${duration.short} ${easing.entrance};
  width: ${spacing.plusQuarter};
  &:focus-visible {
    outline: solid ${spacing.single} ${({ disabled }) => getOutlineColor(!!disabled)};
    box-shadow: 0 0 0 ${pxToRem(2.5)}
      ${({ checked, disabled }) => getBoxShadowColor(!!checked, !!disabled)};
  }
`;

export const Label = styled.label`
  ${body2Medium};
  color: ${colors.textPrimary};
  user-select: none;
  margin-top: ${spacing.eighth};
  margin-bottom: ${spacing.eighth};
`;

export const Description = styled.div`
  ${caption};
  color: ${colors.textSecondary};
`;
